<template>
    <ResizableContent
        class="user-info-widget"
        :class="{ minimized }"
        :handles="['ml']"
        :on-resize="onResize"
        :max-width="maxUserInfoWidgetWidth"
        :min-width="minUserInfoWidgetWidth"
        :width="cloneWidth"
    >
        <div class="collapse-widget" @click="maximize">
            <div class="material-icons">chevron_left</div>
        </div>
        <div class="user-info-head">
            <div class="user-info-details">{{ $t("task.detail") }}</div>
            <div class="material-icons" @click="maximize" v-if="minimized">add</div>
            <div class="material-icons" @click="minimize" v-else>close</div>
        </div>
        <div class="user-info-wrapper">
            <div class="user-info-content">
                <ContactDetail :contact="contact" v-if="tab === 'user-info'" />
                <MetaReferrals :contact="contact" v-if="tab === 'meta-referrals'" />
                <ContactProperties :contact="contact" v-if="tab === 'contact-properties'" />
                <ContactNotes v-if="tab === 'notes'" :visitor-id="contact._id" />
                <ReadyContents v-if="tab === 'ready-contents'" :contact="contact" />
                <AgentList v-if="tab === 'agents'" :contact="contact" />
            </div>
            <div class="user-info-menu">
                <div
                    class="user-info-menu-item"
                    :class="{ selected: tab === 'user-info' }"
                    @click="changeTab('user-info')"
                    content="Contact Details"
                    v-tippy="{ followCursor: true, placement: 'right-end' }"
                    :content="$t('tour.popoverInfo')"
                >
                    <UserInfoSvg />
                </div>
                <div
                    class="user-info-menu-item"
                    :class="{ selected: tab === 'contact-properties' }"
                    @click="changeTab('contact-properties')"
                    content="Contact Properties"
                    v-tippy="{ followCursor: true, placement: 'right-end' }"
                    :content="$t('message.contactProperties')"
                >
                    <span class="material-icons hash-icon" style="font-size: 30px">tag</span>
                </div>
                <div
                    class="user-info-menu-item"
                    :class="{ selected: tab === 'meta-referrals' }"
                    @click="changeTab('meta-referrals')"
                    content="Meta Referrals"
                    v-tippy="{ followCursor: true, placement: 'right-end' }"
                    :content="'Meta Referrals'"
                >
                    <MetaReferralsSVG />
                </div>
                <div
                    class="user-info-menu-item"
                    :class="{ selected: tab === 'notes' }"
                    @click="changeTab('notes')"
                    content="Notes"
                    v-tippy="{ followCursor: true, placement: 'right-end' }"
                    :content="$t('message.notes')"
                >
                    <NotesSvg />
                </div>
                <div
                    class="user-info-menu-item"
                    :class="{ selected: tab === 'agents' }"
                    @click="changeTab('agents')"
                    content="Agents"
                    v-tippy="{ followCursor: true, placement: 'right-end' }"
                    :content="$t('message.agentDetails')"
                >
                    <AgentsSvg />
                </div>
                <div
                    v-if="isLive && !isWatching()"
                    class="user-info-menu-item"
                    :class="{ selected: tab === 'ready-contents' }"
                    @click="changeTab('ready-contents')"
                    content="Ready Contents"
                    v-tippy="{ followCursor: true, placement: 'right-end' }"
                    :content="$t('plans.readyContents')"
                >
                    <ReadyContentsSvg />
                </div>
                <!--
                <div
                    v-if="isLive && !isWatching()"
                    class="user-info-menu-item"
                    :class="{ selected: tab === 'message-search' }"
                    @click="changeTab('message-search')"
                    content="Message Search"
                    v-tippy="{ followCursor: true, placement: 'right-end' }"
                    :content="$t('message.prevChats')"
                >
                    <ConversationHistorySvg />
                </div>
                -->
            </div>
        </div>
    </ResizableContent>
</template>
<script>
import ResizableContent from "./ResizableContent.vue";
import NotesSvg from "./svg/NotesSvg.vue";
import UserInfoSvg from "./svg/UserInfoSvg.vue";
import AgentsSvg from "./svg/AgentsSvg.vue";
import ReadyContentsSvg from "./svg/ReadyContentsSvg.vue";
import ConversationHistorySvg from "./svg/ConversationHistorySvg.vue";
import { mapState } from "vuex";
import ContactNotes from "./ContactNotes.vue";
import ReadyContents from "./ReadyContents.vue";
import ContactDetail from "./ContactDetail.vue";
import AgentList from "./AgentList.vue";
import MessageSearch from "./MessageSearch.vue";
import ContactProperties from "./ContactProperties.vue";
import MetaReferralsSVG from "./svg/MetaReferralsSVG.vue";
import MetaReferrals from "./MetaReferrals.vue";

export default {
    name: "UserInfoWidget",
    components: {
        MetaReferrals,
        MetaReferralsSVG,
        ContactProperties,
        MessageSearch,
        AgentList,
        ContactDetail,
        ReadyContents,
        ContactNotes,
        ConversationHistorySvg,
        ReadyContentsSvg,
        AgentsSvg,
        UserInfoSvg,
        NotesSvg,
        ResizableContent,
    },
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        isLive: {
            type: Boolean,
            default: false,
        },
        contact: {
            type: Object,
            default: () => ({}),
        },
        maxUserInfoWidgetWidth: {
            type: [String, Number],
            default: null,
        },
        minUserInfoWidgetWidth: {
            type: [String, Number],
            default: null,
        },
    },
    data: () => ({
        tab: "user-info",
        minimized: false,
        cloneWidth: 50,
    }),
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
            watchingContactIds: (state) => state.chat.watchingContactIds,
        }),
    },
    methods: {
        changeTab(tab) {
            if (this.minimized) this.maximize();
            this.tab = tab;
        },
        isWatching() {
            return this.watchingContactIds.includes(this.contact._id);
        },
        minimize() {
            this.minimized = true;
            this.cloneWidth = parseInt(`${this.minUserInfoWidgetWidth}`);
            this.$emit("width", this.cloneWidth);
        },
        maximize() {
            this.minimized = false;
            this.cloneWidth = parseInt(`${this.maxUserInfoWidgetWidth * 0.8}`);
            this.$emit("width", this.cloneWidth);
        },
        onResize(handle, x, y, width, height) {
            if (width !== this.cloneWidth) {
                this.cloneWidth = width;
            }
            this.minimized = width <= 80;
            this.$emit("width", width);
        },
    },
    beforeMount() {
        const width = localStorage.getItem("user-info-widget-width") || `${this.maxUserInfoWidgetWidth * 0.7}`;
        this.cloneWidth = parseInt(width);
        this.minimized = this.cloneWidth <= 80;
        this.$emit("width", this.cloneWidth);
    },
    watch: {
        cloneWidth() {
            localStorage.setItem("user-info-widget-width", this.cloneWidth);
        },
    },
};
</script>
<style lang="scss">
.user-info-widget {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-left: 1px solid var(--border-neutral-default);
    position: relative;

    .collapse-widget {
        width: 30px;
        height: 30px;
        background: var(--color-bg-neutral-default);
        border: 1px solid var(--border-neutral-default);
        border-radius: 40px;
        position: absolute;
        top: 50%;
        left: -15px;
        display: none;
        align-items: center;
        justify-content: center;
        user-select: none;
        cursor: pointer;
    }

    &.minimized {
        .user-info-content,
        .user-info-details,
        .user-info-content {
            display: none !important;
        }

        .user-info-menu {
            width: 100% !important;
        }

        .user-info-head {
            justify-content: center;
        }

        .collapse-widget {
            display: flex;
        }
    }
    .user-info-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        border-bottom: 1px solid var(--border-neutral-default);
        padding: 10px;
        font-weight: bold;
        font-size: 16px;
        user-select: none;
        color: #22272d;
        .material-icons {
            font-size: 18px;
        }
    }

    .user-info-wrapper {
        display: flex;
        width: 99%;
        height: 100%;
        overflow: hidden;

        .user-info-content {
            width: 100%;
            height: 100%;
            border-right: 1px solid var(--border-neutral-default);
            overflow: hidden;
            overflow-y: auto;
            .user-info-details {
                padding: 15px;
            }

            &::-webkit-scrollbar {
                display: none;
            }

            &-title {
                font-weight: bold;
                font-size: 16px;
                display: flex;
                align-items: center;

                &.sp-between {
                    justify-content: space-between;
                }

                &-actions {
                    display: flex;
                    align-items: center;
                    gap: 4px;

                    &-button {
                        width: 30px;
                        height: 30px;
                        cursor: pointer;
                        user-select: none;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        line-height: 0;

                        .material-icons {
                            font-size: 18px;
                        }
                    }
                }
            }
        }

        .user-info-menu {
            min-width: 50px;
            width: 50px;
            height: 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            gap: 4px;
            padding: 10px;

            &::-webkit-scrollbar {
                display: none;
            }

            .user-info-menu-item {
                padding: 5px;
                line-height: 0;
                border-radius: 2px;
                position: relative;
                &:hover,
                &.selected {
                    .hash-icon {
                        color: #5625cc;
                    }
                }
                .hash-icon {
                    cursor: default;
                    color: #8796af;
                }
                /*
                &:hover {
                    &::before {
                        content: attr(content);
                        position: absolute;
                        top: 0;
                        right: calc(100% - 1px);
                        height: 100%;
                        background: #22272d;
                        z-index: 9999;
                        display: flex;
                        align-items: center;
                        color: white;
                        width: max-content;
                        padding: 0px 10px;
                    }
                }
*/
                &:hover,
                &.selected {
                    svg {
                        width: 25px;
                        height: 25px;

                        path {
                            //todo: color selector
                            fill: #5625cc;
                        }
                    }
                }
            }

            svg {
                width: 25px;
                height: 25px;

                path {
                    //todo: color selector
                    fill: #8796af;
                }
            }
        }
    }
}
</style>
